<template>
  <div class="d-flex justify-content-between w-100 wrap-d-class">
    <!-- BUY Orders -->
    <div
      v-if="adOrderEntity && adOrderEntity.orderType === 'BUY'"
      class="pl-0 full-size-mb col-lg-8"
    >
      <div class="d-flex mb-1">
        <h3 class="mb-0 back_button">
          <BackButton />
          <span v-if="adOrderEntity.orderStatus === 'CREATED'">
            {{ $t("orderCreated.Order-Created") }}
          </span>
          <span v-else-if="adOrderEntity.orderStatus === 'IN_DISPUTE'">
            {{ $t("orderCreated.orderCreated") }}
          </span>
          <span v-else-if="adOrderEntity.orderStatus === 'PAYMENT_SENT'">
            {{ $t("orderCreated.WaitingConfirmation") }}
          </span>
          <span v-else-if="adOrderEntity.orderStatus === 'COMPLETED'">
            {{ $t("orderCreated.OrderCompleted") }}
          </span>
          <span v-else-if="adOrderEntity.orderStatus === 'CANCELLED'">
            {{ $t("orderCreated.OrderCancelled") }}
          </span>
        </h3>
      </div>

      <div class="order-detail-time">
        <div v-if="adOrderEntity.orderStatus === 'CREATED'">
          {{ $t("orderCreated.Order-Created-brief") }}
          <span class="timer-color">{{ remainingTime }}</span>
        </div>

        <div v-else-if="adOrderEntity.orderStatus === 'PAYMENT_SENT'">
          {{ $t("orderCreated.WaitingConfirmationBrief") }}
          <span class="timer-color">{{ remainingTime }}</span>
        </div>

        <div v-else-if="adOrderEntity.orderStatus === 'COMPLETED'">
          {{ $t("orderCreated.SuccessfullyPurchased") }}
          <span class="timer-color">
            {{
              user?.id !== adOrderEntity.adUserId
                ? `${adOrderEntity.finalQuantity} ${adOrderEntity.coin}`
                : `${adOrderEntity.totalQuantity} ${adOrderEntity.coin}`
            }}
          </span>
        </div>

        <div v-else-if="adOrderEntity.orderStatus === 'IN_DISPUTE'">
          {{ $t("orderCreated.PleaseCheckTheStatusOfTheDispute") }}
        </div>
      </div>
    </div>

    <!-- SELL Orders -->
    <div
      v-else-if="adOrderEntity && adOrderEntity.orderType === 'SELL'"
      class="pl-0 full-size-mb col-lg-8"
    >
      <div class="d-flex mb-1">
        <h3 class="mb-0 back_button">
          <BackButton />
          <span v-if="adOrderEntity.orderStatus === 'CREATED'">
            {{ $t("orderCreated.SellOrder-Created") }}
          </span>
          <span v-else-if="adOrderEntity.orderStatus === 'IN_DISPUTE'">
            {{ $t("orderCreated.orderCreated") }}
          </span>
          <span v-else-if="adOrderEntity.orderStatus === 'PAYMENT_SENT'">
            {{ $t("orderCreated.VerifyPayment") }}
          </span>
          <span v-else-if="adOrderEntity.orderStatus === 'COMPLETED'">
            {{ $t("orderCreated.OrderCompleted") }}
          </span>
          <span v-else-if="adOrderEntity.orderStatus === 'CANCELLED'">
            {{ $t("orderCreated.OrderCancelled") }}
          </span>
        </h3>
      </div>

      <div class="order-detail-time">
        <div v-if="adOrderEntity.orderStatus === 'CREATED'">
          {{ $t("orderCreated.SellOrder-Created-brief") }}
          <span class="timer-color">{{ remainingTime }}</span>
        </div>

        <div v-else-if="adOrderEntity.orderStatus === 'PAYMENT_SENT'">
          {{ $t("orderCreated.VerifyPaymentBrief") }}
          <span class="timer-color">{{ remainingTime }}</span>
        </div>

        <div v-else-if="adOrderEntity.orderStatus === 'IN_DISPUTE'">
          {{ $t("orderCreated.PleaseCheckTheStatusOfTheDispute") }}
        </div>

        <div v-else-if="adOrderEntity.orderStatus === 'COMPLETED'">
          {{ $t("orderCreated.SuccessfullySold") }}
          <span class="timer-color">
            {{
              user?.id !== adOrderEntity.adUserId
                ? `${adOrderEntity.finalQuantity} ${adOrderEntity.coin}`
                : `${adOrderEntity.totalQuantity} ${adOrderEntity.coin}`
            }}
          </span>
        </div>
      </div>
    </div>

    <!-- Order Number / Meta info block -->
    <div class="order-num pl-0 text-lg-right full-size-mb col-lg-4 col-sm-6">
      <div class="order-id-block">
        <div class="chat-box-mobile">
          <div>
            <div class="order-created-text d-inline">
              {{ $t("orderCreated.Order-number") }}
            </div>
            <div class="d-inline-flex ml-1">
              <span>{{ adOrderEntity?.id }}</span>
              <Copy
                v-b-tooltip.hover.v-primary
                class="pointer ml-1"
                :title="$t('wallet.Copy')"
                @click="copy(adOrderEntity?.id)"
              />
            </div>
            <div>
              <div class="order-created-text d-inline">
                {{ $t("orderCreated.Time-created") }}
              </div>
              <div class="d-inline ml-1">
                {{ dateFormat(adOrderEntity?.createdTime) }}
              </div>
            </div>
          </div>
          <Chat />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import { mapState } from 'vuex';
import moment from 'moment';
import Copy from '@/assets/rashi-coin/copy.svg';
import Message from '@/assets/rashi-coin/message.svg';
import Wait from '@/assets/rashi-coin/wait.svg';
import Chat from '@/layouts/components/buy-sell/Chat.vue';
import BackButton from '@/layouts/components/BackButton.vue';
import copyToClipboard from '@/utils/clipboard';

export default {
  name: 'BuyOrderText',
  components: {
    Copy,
    Message,
    Chat,
    Wait,
    BackButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    adOrderEntity: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    remainingTime: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    ...mapState('user', ['user']),
  },
  methods: {
    async copy(text) {
      if (text) {
        await copyToClipboard.apply(this, [`${text}`]);
      }
    },
    dateFormat(dateTime) {
      if (!dateTime) return '';
      const str = String(dateTime).trim();
      const cleanDate = str.endsWith('Z') || str.includes('+') ? str : `${str}Z`;
      const m = moment(cleanDate);
      if (m.isValid()) {
        return m.format('YYYY-MM-DD HH:mm:ss');
      }
      const mRaw = moment(str);
      return mRaw.isValid() ? mRaw.format('YYYY-MM-DD HH:mm:ss') : '';
    },
  },
};
</script>

<style scoped>
.timer-color {
  color: var(--primary);
}
.order-created .order-created-text {
  color: #707a8a;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
@media (min-width: 430px) and (max-width: 991px) {
  [dir] .order-num {
    margin-top: 16px;
  }
}
@media (min-width: 991px) {
  .chat {
    display: none;
  }
}
@media (max-width: 991px) {
  .chat {
    width: 10vw;
    height: 5vh;
  }
}
.Wait-size {
  height: 20px;
  width: 30px;
}
</style>
